import { useEffect, useRef, useState } from 'react';
import { scroller } from 'react-scroll';

export const useDebouncedScrollSnap = ({
  activePage,
  containerId,
  debounceDuration = 1000,
  scrollDuration = 300,
}: {
  activePage: string;
  containerId: string;
  debounceDuration?: number;
  scrollDuration?: number;
}) => {
  const [stablePage, setStablePage] = useState<string | null>(null);
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!activePage) return;
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(
      () => setStablePage(activePage),
      debounceDuration
    );
    return () => {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    };
  }, [activePage, debounceDuration]);

  useEffect(() => {
    if (!stablePage) return;
    scroller.scrollTo(stablePage, {
      containerId,
      smooth: 'easeOutQuart',
      duration: scrollDuration,
    });
  }, [stablePage, containerId, scrollDuration]);
};
